$(function(){
	var formEl = $('.form');

	// open dropdown
	formEl.on('click', '.form-type__front', function(){
		var thisEl 			= $(this);
		var typeEl 			= thisEl.closest('.form-type');
		var dropDownEl 	= typeEl.find('.form-type__dropdown');

		// make repeater field active
		var repeaterItemEl = thisEl.closest('.form-repeater__item');
		$('.form-repeater__item').removeClass('form-repeater__item--type-active');
		repeaterItemEl.addClass('form-repeater__item--type-active');

		// open dropdown
		dropDownEl.slideToggle(100);
	});

	// change front button on choice click
	formEl.on('click', '.form-type__choice', function(){
		var thisEl 			 = $(this);
		var typeEl       = thisEl.closest('.form-type');
		var frontEl  		 = typeEl.find('.form-type__front');
		var dropDownEl   = typeEl.find('.form-type__dropdown');
		var choiceImgEl  = thisEl.find('img');
		var choiceValue  = thisEl.attr('data-value');
		var frontImgEl   = frontEl.find('img');
		var frontInputEl = frontEl.find('input');

		// set front image
		frontImgEl.attr('src', choiceImgEl.attr('src'));

		// set front input value
		frontInputEl.val(choiceValue);

		// hide dropdown
		dropDownEl.hide();
	});

	// close dropdowns on click outside
	$('body').on('click', function(e){
		var targetEl   = $(e.target);
		var typeEl     = targetEl.closest('.form-type');
		var dropDownEl = typeEl.find('.form-type__dropdown');

		// hide dropdown
		$('.form-type__dropdown').not(dropDownEl).hide();
	})
});